export default __webpack_public_path__ + "static/media/image_icon.a09f54ea.svg";